module.exports = __webpack_public_path__ + "static/media/black_writing_hours.139a7b8e.svg";